import SmoothScroll from 'smooth-scroll';

// Main page paths for production and development
const mainPaths = ['/static/app/', '/app/', '/'];

window.addEventListener('load', () => {
	window.scrollTo(0, 0);
	const hash = window.location.hash;

	if (hash) {
		setTimeout(() => {
			const anchor = document.querySelector(hash);
			if (anchor) {
				window.fScrollToElement(anchor);
			}
		}, 700);
	}

	document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach((link) => {
		if (mainPaths.includes(window.location.pathname)) {
			link.addEventListener('click', (event) => {
				event.preventDefault();

				// nav.querySelectorAll('a[href^="#"]').forEach((item) => {
				// 	item.classList.remove('active');
				// });

				// link.classList.add('active');

				let anchor = document.querySelector(event.target.getAttribute('href').replace('/', ''));

				// Check if user is on main page
				if (mainPaths.includes(window.location.pathname)) {
					anchor = document.querySelector(event.target.getAttribute('href').replace('/', ''));
				}

				if (anchor) {
					window.fScrollToElement(anchor);
				}
			});
		}
	});
});

// Scroll to element on custom  event
window.addEventListener('bw-scroll-to-element', (e) => {
	// Get element to scroll to
	const target = e.detail.target;
	if (target) {
		window.fScrollToElement(target);
	}
});

/**
 *
 * @param {htmlElement} element - element to which page should scroll
 * @param {bool} updateURL - if url should be updated with #target after scroll
 * Pin function to window, so it may be used anywhere
 */
window.fScrollToElement = (element, updateUrl = true, constOffset = false) => {
	return new Promise((resolve, reject) => {
		if (element) {
			let scroll = new SmoothScroll();

			// Add listener to return callback when scroll stops
			const listener = () => {
				document.removeEventListener('scrollStop', listener, false);

				resolve('scroll finished');
			};

			document.addEventListener('scrollStop', listener, false);

			let offset = 100;

			// if (constOffset) {
			// 	offset = 100;
			// }

			if (window.innerWidth <= 991) {
				offset = 80;
			}

			// Animate to element with given options
			scroll.animateScroll(element, 0, {
				speed: 500,
				speedAsDuration: true,
				offset: 50,
				updateURL: updateUrl,
				offset: offset,
			});
		}
	});
};
